export const blockIconsAudioandvideoNewReleases = (
	<span className='material-symbols-outlined'>new_releases</span>
);
